<template>
  <div class="myInfo_container">
    <div class="header">
      <span>{{ $t('lang.external.personal.content.six.个人信息') }}</span>
    </div>
    <div class="info_content">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          :label="$t('lang.external.personal.content.six.姓名')"
          prop="stuName"
        >
          <el-input
            :placeholder="$t('lang.external.personal.content.six.请输入姓名')"
            v-model="ruleForm.stuName"
            clearable
            class="info_Input"
            type="text"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          :label="$t('lang.external.personal.content.six.性别')"
          prop="sex"
          label-position="right"
          class="itemlabel"
        >
          <el-select
            v-model="selectValue"
            class="info_select"
            @change="searchSelect(selectValue)"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :value="item.label"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          :label="$t('lang.external.personal.content.six.学号')"
          prop="stuNum"
        >
          <el-input
            :placeholder="$t('lang.external.personal.content.six.请输入学号')"
            v-model="ruleForm.stuNum"
            clearable
            class="info_Input"
            type="number"
          >
          </el-input>
        </el-form-item>

        <el-form-item
          :label="$t('lang.external.personal.content.six.班级')"
          prop="className"
        >
          <el-input
            :placeholder="$t('lang.external.personal.content.six.请输入班级')"
            v-model="ruleForm.className"
            clearable
            class="info_Input"
          >
          </el-input>
        </el-form-item>

        <div class="submit">
          <div class="per-button btn-active" @click="saveInfo('ruleForm')">
            {{ $t('lang.external.personal.content.six.保存') }}
          </div>
          <div class="per-button btn-active mar_left" @click="outLogin">
            {{ $t('lang.external.personal.content.six.退出登录') }}
          </div>
        </div>
        <div class="loginOut"></div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { modifyInfos } from '@/api/personalCenter/index'
export default {
  data() {
    return {
      selectValue: this.$store.state.userInfo.sex,
      ruleForm: {
        stuName: this.$store.state.userInfo.stuName,
        userMobile: this.$store.state.userInfo.userMobile,
        className: this.$store.state.userInfo.className,
        stuNum: this.$store.state.userInfo.stuNum,
      },
      rules: {
        stuName: [
          {
            required: true,
            message: this.$t('lang.external.personal.content.six.请输入姓名'),
            trigger: 'blur',
          },
          {
            min: 2,
            max: 16,
            message: this.$t(
              'lang.external.personal.content.six.长度在2到16个字符'
            ),
            trigger: 'blur',
          },
        ],
        stuNum: [
          {
            required: true,
            message: this.$t('lang.external.personal.content.six.请输入学号'),
            trigger: 'blur',
          },
          {
            min: 2,
            max: 16,
            message: this.$t(
              'lang.external.personal.content.six.长度在2到16个字符'
            ),
            trigger: 'blur',
          },
        ],
        userMobile: [
          {
            required: true,
            message: this.$t('lang.external.personal.content.six.请输入手机号'),
            trigger: 'blur',
          },
          {
            min: 2,
            max: 16,
            message: this.$t(
              'lang.external.personal.content.six.长度在2到16个字符'
            ),
            trigger: 'blur',
          },
        ],
        className: [
          {
            required: true,
            message: this.$t('lang.external.personal.content.six.请输入班级'),
            trigger: 'blur',
          },
          {
            min: 2,
            max: 16,
            message: this.$t(
              'lang.external.personal.content.six.长度在2到16个字符'
            ),
            trigger: 'blur',
          },
        ],
      },
      options: [
        {
          value: '1',
          label: this.$t('lang.external.personal.content.six.男'),
        },
        {
          value: '2',
          label: this.$t('lang.external.personal.content.six.女'),
        },
      ],
    }
  },
  methods: {
    saveInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          modifyInfos({
            stuName: this.ruleForm.stuName,
            sex: this.selectValue,
            stuNum: this.ruleForm.stuNum,
            className: this.ruleForm.className,
          }).then((res) => {
            this.$router.go(0)
          })
        } else {
          return false
        }
      })
    },
    //退出登录
    outLogin() {
      this.$confirm(
        this.$t('lang.external.personal.content.six.是否退出登录?'),
        this.$t('lang.external.personal.content.six.提示'),
        {
          confirmButtonText: this.$t('lang.external.personal.content.six.确定'),
          cancelButtonText: this.$t('lang.external.personal.content.six.取消'),
          type: 'warning',
        }
      ).then(() => {
        this.$router.push('/home')
        this.$store.commit('SETUSERLOGIN', false)
        window.localStorage.removeItem('token')
      })
    },
    searchSelect(value) {
      this.selectValue = value
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  computed: {},
  mounted() {},
}
</script>
<style lang="scss" scoped>
.myInfo_container {
  width: 100%;
}
.header {
  height: 40px;
  background-color: #dce9f3;
  line-height: 40px;
}
.header span {
  width: 65px;
  height: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #0c5893;
  line-height: 18px;
  margin-left: 26px;
}
.info_content {
  padding: 0 30px 30px 0;
}
.info_Input {
  width: 300px;
}
span {
  font-size: 14px;
  font-weight: 400;
  color: #666666;
}
.magin_right {
  margin-right: 30px;
}
.magin_top {
  margin-top: 16px;
}
.info_select {
  width: 300px;
}
.save_button_box {
  margin-top: 53px;
}
.el-form {
  // width: 40%;
  padding: 20px 30px;
  .submit {
    display: flex;
    align-items: center;
  }
}
.mar_left {
  margin-left: 20px;
  background-color: #b8b5b5;
  border: none;
}
::v-deep .el-form--label-left .el-form-item__label {
  text-align: left;
}
</style>